import { Injectable } from '@angular/core';
import { AgentCampaignWizardService } from '../agent-campaign-wizard.service';
import { BehaviorSubject, map } from 'rxjs';
import { BaseFormService } from '../../../utils/base-form-service';
import { CampaignLogoHeadshot, AgentCampaignKeys, AgentCampaignStepName } from '@ag-common-lib/public-api';

@Injectable()
export class AgentCampaignLogoHeadshotService extends BaseFormService<Partial<CampaignLogoHeadshot>> {
  formData$ = new BehaviorSubject<CampaignLogoHeadshot>(this.formData);

  constructor(private agentCampaignWizardService: AgentCampaignWizardService) {
    super();

    const campaignLogoHeadshot$ = this.agentCampaignWizardService.campaign$.pipe(
      map(campaign => {
        const logoHeadshot = campaign?.[AgentCampaignKeys.data]?.[AgentCampaignStepName.logoHeadshot];
        const draftSocial = campaign?.[AgentCampaignKeys.draftData]?.[AgentCampaignStepName.logoHeadshot];

        return Object.assign({}, logoHeadshot, draftSocial);
      }),
    );

    campaignLogoHeadshot$.subscribe(this.getFormData);
  }

  handleNextStepClick = async () => {
    const changes = this.formChangesDetector.getAllChanges();

    if (!changes?.length) {
      this.agentCampaignWizardService.nextStep();
      return;
    }

    const updates = {};

    changes.forEach(([key]) => {
      Object.assign(updates, { [key]: this.formData[key] });
    });

    this.startProgress();
    await this.agentCampaignWizardService
      .handleStepChanges({
        [AgentCampaignStepName.logoHeadshot]: updates,
      })
      .then(() => {
        this.formChangesDetector.clear();
        this.agentCampaignWizardService.nextStep();
      })
      .finally(() => {
        this.stopProgress();
      });
  };

  public handleCustomItemCreating = e => {
    const url = e?.text;

    if (!url) {
      Object.assign(e, { customItem: null });
      return;
    }

    const customItem = { url, visible: false };

    Object.assign(e, { customItem });
  };

  private getFormData = (campaignLogoHeadshot?: Partial<CampaignLogoHeadshot>) => {
    const initialData = Object.assign({}, campaignLogoHeadshot);
    this.formData = new Proxy(initialData, {
      set: (target, prop, value, receiver) => {
        const prevValue = target[prop];
        if (value !== prevValue) {
          this.formChangesDetector.handleChange(prop, value, prevValue);
          Reflect.set(target, prop, value, receiver);

          switch (prop) {
            case '':
          }
        }

        return true;
      },
    });

    this.formData$.next(this.formData);
  };
}
